const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class LaunchesCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    const slideCount = this.els.slide.elements.length

    const smDisabled = slideCount < 2.3
    const lgDisabled = slideCount <= 3

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 8,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: smDisabled,
            slides: {
              perView: 2.3,
              spacing: 8,
            },
          },
          '(min-width: 1201px)': {
            disabled: lgDisabled,
            slides: {
              perView: 3,
              spacing: 8,
            },
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('launches-carousel')) {
  customElements.define('launches-carousel', LaunchesCarousel)
}
